import { gql } from '@apollo/client'

const USER_ALLOCATION_COUNTS_QUERY = gql`
  query userAllocationCountsQuery($id: ID!) {
    userAllocationCounts(id: $id) {
      userId
      allocationCount
    }
  }
`

export default USER_ALLOCATION_COUNTS_QUERY
